// extracted by mini-css-extract-plugin
export default {"root":"CriminalCheckConsent_root__ets9G"};